<template>
  <social-sharing
    :networks="overriddenNetworks"
    :url="'https://portal.olympian.guru' + this.$route.fullPath"
    :title="this.drillName"
    :description="this.drillName"
    :quote="
      'https://portal.olympian.guru' + this.$route.fullPath + this.drillDesc
    "
    :hashtags="this.sportType + ',' + this.tags"
    :media="this.videoUrl"
    twitter-user="OlympianGuru"
    inline-template
  >
    <div>
      <network network="email" id="email_social_share">
        <v-icon size="24px">fa fa-envelope</v-icon>&nbsp;
      </network>
      <!-- <network network="custom">
          <v-icon size="24px">fas fa-link</v-icon>&nbsp;
      </network>       -->
      <network network="facebook" id="facebook_social_share">
        <v-icon>fab fa-facebook</v-icon>&nbsp;</network
      >
      <!-- <network network="instagram">
        <i class="fa fa-instagram"></i> &nbsp;
      </network> -->
      <!-- <network network="line">
        <v-icon>fab fa-line</v-icon>&nbsp;
      </network> -->
      <network network="linkedin" id="linkedin_social_share">
        <v-icon>fab fa-linkedin</v-icon>&nbsp;
      </network>
      <network network="odnoklassniki" id="odnoklassniki_social_share">
        <v-icon>fab fa-odnoklassniki</v-icon>&nbsp;
      </network>
      <network network="telegram" id="telegram_social_share">
        <v-icon>fab fa-telegram</v-icon> &nbsp;
      </network>
      <network network="twitter" id="twitter_social_share">
        <v-icon>fab fa-twitter</v-icon> &nbsp;
      </network>
      <network network="whatsapp" id="whatsapp_social_share">
        <v-icon>fab fa-whatsapp</v-icon> &nbsp;
      </network>
      <!-- <network network="pinterest">
        <v-icon>fab fa-pinterest</v-icon>&nbsp;
      </network>
      <network network="reddit">
        <v-icon>fab fa-reddit</v-icon>&nbsp;
      </network>
      <network network="skype">
        <v-icon>fab fa-skype</v-icon> &nbsp;
      </network> -->
      <!--network network="sms">
        <v-icon>far fa-comment-dots</v-icon> SMS
      </network-->
      <!-- <network network="vk">
        <v-icon>fab fa-vk</v-icon> &nbsp;
      </network>
      <network network="weibo">
        <v-icon>fab fa-weibo</v-icon> &nbsp;
      </network>  -->
    </div>
  </social-sharing>
</template>

<script>
export default {
  props: [
    "drillName",
    "drillDesc",
    "tags",
    "videoUrl",
    "sportType",
    "imageUrl"
  ],
  data() {
    return {
      overriddenNetworks: {
        custom: {
          sharer: "https://mycustomdomain.com",
          type: "popup"
        }
      }
    };
  },
  mounted() {}
};
</script>
